import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FaBars, FaTimes, FaUser, FaPalette } from 'react-icons/fa';
import './Navbar.css';
import logo from '../assets/images/logoCanvaNew.png';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { user, logout, isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
    setMenuOpen(false);
  }; 
  
  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <nav className="navbar">
      <div className="container">
        <div className="navbar-content">
          <Link to="/" className="logo">
            <img src={logo} alt="Canvaart Logo" className="logo-image" />
          </Link>

          <div className={`nav-links ${menuOpen ? 'active' : ''}`} id="nav-links">
            <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
            <Link to="/gallery" onClick={() => setMenuOpen(false)}>Gallery</Link>
            <Link to="/auctions" onClick={() => setMenuOpen(false)}>Auctions</Link>
            <Link to="/custom-request" onClick={() => setMenuOpen(false)}>Custom Request</Link>
            <Link to="/blog" onClick={() => setMenuOpen(false)}>Blog</Link>
            <Link to="/about" onClick={() => setMenuOpen(false)}>About</Link>
            
            {user ? (
              <>
                {isAdmin() && (
                  <Link to="/super-adminp" onClick={() => setMenuOpen(false)} className="admin-link">
                    Admin Panel
                  </Link>
                )}
                <button onClick={handleLogout} className="btn-logout" aria-label={`Logout ${user.name}`}>
                  Logout ({user.name})
                </button>
              </>
            ) : (
              <Link to="/login" onClick={() => setMenuOpen(false)}>
                <button className="btn-login" aria-label="Login to your account">
                  <FaUser aria-hidden="true" /> Login
                </button>
              </Link>
            )}
          </div>

          <button
            className="menu-toggle"
            onClick={toggleMenu}
            aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
            aria-expanded={menuOpen}
            aria-controls="nav-links"
          >
            {menuOpen ? <FaTimes aria-hidden="true" /> : <FaBars aria-hidden="true" />}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
